import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Paper,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow,
    Typography
} from "@material-ui/core";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import {
    FilterContentStyled,
    FormContentMainStyled,
    FormContentSizeTableMainStyled,
    PushStatusBadgeStyled
} from "../styled";
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import DateUtil from "../../../../Utils/DateUtil";
import PaginationComponent
    from "../../../../Components/PaginationComponent/PaginationComponent";

class TableHistoryMensageriaComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            erros: [],
            search: '',
        };
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    formatDate(rawDate) {
        if (!rawDate) return '-';
        try {
            return DateUtil.raw(rawDate).toDateTime24();
        } catch (e) {
            return rawDate;
        }
    }

    render() {
        const { history, pagination } = this.props;

        return (
            <FormContentMainStyled>
                <FormContentSizeTableMainStyled>
                    <SpacerComponent height={40}/>
                    <Typography align={'left'}
                                variant={'h6'}
                                color={'primary'}>
                        Filtros
                    </Typography>

                    <FilterContentStyled>
                        <TextFieldDefault label={'Busque por assunto ou mensagem *'}
                                          name={'search'}
                                          type={'text'}
                                          value={this.state.search}
                                          onChange={(event) => this.handleChange(event)}
                                          erros={this.props.erros}
                                          width={'350px'}
                        />
                        <SpacerComponent width={20}/>
                        <Button variant={'contained'}
                                color={'primary'}
                                size={"large"}
                                fullWidth={false}
                                onClick={() => {
                                    if (this.props.onChangePage) {
                                        this.props.onChangePage(1, this.state.search || '');
                                    }
                                }}>
                            Filtrar
                        </Button>
                    </FilterContentStyled>
                    <SpacerComponent height={20}/>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Assunto</TableCell>
                                    <TableCell>Data de Envio</TableCell>
                                    <TableCell>Destinatários</TableCell>
                                    <TableCell>Leituras</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {history && history.length > 0 ? (
                                    history.map((item, index) => {
                                        const sentAt = this.formatDate(item.sent_at || item.created_at);
                                        const isSent = item.status === 'sent';
                                        const statusLabel = isSent ? 'Enviado' : item.status;
                                        const recipientsLabel = item.send_to_all
                                            ? 'Todos os clientes'
                                            : `${item.total_recipients || 0} cliente(s)`;
                                        const readLabel = `${item.read_count || 0} (${item.read_percent || 0}%)`;

                                        return (
                                            <TableRow key={item.uuid || index}>
                                                <TableCell><b>{item.subject}</b></TableCell>
                                                <TableCell>{sentAt}</TableCell>
                                                <TableCell>{recipientsLabel}</TableCell>
                                                <TableCell>{readLabel}</TableCell>
                                                <TableCell>
                                                    <PushStatusBadgeStyled active={isSent}>
                                                        {statusLabel}
                                                    </PushStatusBadgeStyled>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Button color="primary"
                                                            size="small"
                                                            style={{ textTransform: 'none', fontWeight: 'bold' }}
                                                            onClick={() => this.props.onOpenDetails && this.props.onOpenDetails(item.uuid)}>
                                                        Detalhes
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            Nenhum histórico encontrado
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <SpacerComponent height={16}/>
                    {pagination && (
                        <PaginationComponent
                            total={parseInt(pagination?.total || 0)}
                            perPage={parseInt(pagination?.per_page || 15)}
                            currentPage={parseInt(pagination?.current_page || 1)}
                            lastPage={parseInt(pagination?.last_page || 1)}
                            itensVisible={2}
                            onChangePage={(page) => {
                                if (this.props.onChangePage) {
                                    this.props.onChangePage(page, this.state.search || '');
                                }
                            }}
                        />
                    )}
                    <SpacerComponent height={32}/>
                </FormContentSizeTableMainStyled>
            </FormContentMainStyled>
        );
    }
}

TableHistoryMensageriaComponent.defaultProps = {
    history: [],
    pagination: null,
    onChangePage: () => {},
    onOpenDetails: () => {},
    erros: {},
};

TableHistoryMensageriaComponent.propTypes = {
    history: PropTypes.array,
    pagination: PropTypes.object,
    onChangePage: PropTypes.func,
    onOpenDetails: PropTypes.func,
    erros: PropTypes.object,
};

export default TableHistoryMensageriaComponent;
